import React from 'react';
import { useIntl } from '@kyruus/intl';
import type { Log } from 'Src/types';
import { Box } from '@biome-design-system/ui/Box';
import { Button } from '@biome-design-system/ui/Button';
import { Typography } from '@biome-design-system/ui/Typography';
import { sanitizeHref } from 'Src/utils/sanitizeHref';
import { messages } from '../messages';

interface PatientPortalSectionProps {
  patientPortalUrl: string;
  log: Log;
}

export const PatientPortalSection = ({
  patientPortalUrl,
  log
}: PatientPortalSectionProps) => {
  const intl = useIntl();
  const onClick = () => {
    log('user_action.no_results.patient_portal_button_clicked');
  };
  return (
    <Box
      component="section"
      sx={(theme) => ({
        backgroundColor: theme.palette.background.secondary
      })}
    >
      <Typography
        variant="body1"
        component="h2"
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightBold,
          marginBottom: theme.spacing(1)
        })}
      >
        {intl.formatMessage(messages.patientPortalHeading)}
      </Typography>
      <Typography
        variant="body1"
        sx={(theme) => ({
          color: theme.palette.grey[700],
          marginBottom: theme.spacing(2)
        })}
      >
        {intl.formatMessage(messages.patientPortalDescription)}
      </Typography>
      <Button
        component="a"
        href={sanitizeHref(patientPortalUrl)}
        variant="contained"
        color="primary"
        onClick={onClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage(messages.patientPortalButton)}
      </Button>
    </Box>
  );
};
